import React from 'react';
import classNames from 'classnames';
import Dialog, { DialogProps } from '../../../../components/dialog/Dialog';
import { useEditor } from '@mnz/builder';

const convertFontName = (name: string) => name.split(/(?=[A-Z][a-z])/).join(' ');
interface FontModalProps extends DialogProps {
    onSelectFontType: (type: string) => void;
}
const FontModal: React.FC<FontModalProps> = ({ onSelectFontType, ...props }) => {
    const { designSettings } = useEditor();

    return (
        <Dialog {...props}>
            <div className="mt-20 px-30 pb-40 overflow-hidden">
                <div className="overflow-y-auto max-h-[230px] ">
                    <div
                        className={classNames({
                            'px-15 pt-10 pb-15 border rounded-8 border-primary-40 mb-10': true,
                        })}
                        onClick={() => onSelectFontType('primary')}
                    >
                        <div className="text-18" style={{ fontFamily: designSettings?.fonts?.primary?.fontFamily }}>
                            Primary
                        </div>
                        <p className="text-12 leading-13">
                            {designSettings?.fonts?.primary?.fontFamily &&
                                convertFontName(designSettings?.fonts?.primary?.fontFamily)}
                        </p>
                    </div>
                    <div
                        className={classNames({
                            'px-15 pt-10 pb-15 border rounded-8 border-primary-40': true,
                        })}
                        onClick={() => onSelectFontType('secondary')}
                    >
                        <div className="text-18" style={{ fontFamily: designSettings?.fonts?.secondary?.fontFamily }}>
                            Secondary
                        </div>
                        <p className="text-12 leading-13">
                            {designSettings?.fonts?.secondary &&
                                convertFontName(designSettings?.fonts?.secondary?.fontFamily)}
                        </p>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default FontModal;
